export function InvoiceIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M12.3,12.45H7.7A.77.77,0,0,0,7.7,14h4.6a.77.77,0,1,0,0-1.54Z" />
      <path d="M6.93,10.15a.76.76,0,0,0,.77.76h4.6a.77.77,0,1,0,0-1.53H7.7A.76.76,0,0,0,6.93,10.15Z" />
      <path d="M15.69,6,12.34,2.63a1.51,1.51,0,0,0-1.08-.45H6.16a2.3,2.3,0,0,0-2.3,2.3V15.94a2.3,2.3,0,0,0,2.3,2.3h7.68a2.3,2.3,0,0,0,2.3-2.3V7.07A1.54,1.54,0,0,0,15.69,6Zm-1.08,10a.78.78,0,0,1-.77.77H6.16a.78.78,0,0,1-.77-.77V4.48a.78.78,0,0,1,.77-.77h5.1l3.35,3.36Z" />
    </svg>
  )
}
